import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type ReactNode } from 'react'

// Create a singleton query client for the app
let queryClient: QueryClient | undefined

export function getQueryClient() {
	if (!queryClient) {
		queryClient = new QueryClient({
			defaultOptions: {
				queries: {
					// With SSR, we usually want to set some default staleTime
					// above 0 to avoid refetching immediately on the client
					staleTime: 60 * 1000, // 1 minute
					gcTime: 5 * 60 * 1000, // 5 minutes (previously cacheTime)
					retry: (failureCount, error) => {
						// Don't retry on 4xx errors
						if (error && typeof error === 'object' && 'status' in error) {
							const status = (error as any).status
							if (status >= 400 && status < 500) {
								return false
							}
						}
						return failureCount < 3
					},
				},
			},
		})
	}
	return queryClient
}

interface DataFetchingProviderProps {
	children: ReactNode
}

export function DataFetchingProvider({ children }: DataFetchingProviderProps) {
	const queryClient = getQueryClient()

	return (
		<QueryClientProvider client={queryClient}>
			{children}
			{process.env.NODE_ENV === 'development' && (
				<ReactQueryDevtools initialIsOpen={false} />
			)}
		</QueryClientProvider>
	)
}